// hooks/useBranding.js

import { useContext } from "react";
import { BrandingContext } from "../contexts/BrandingContext";

export const useBranding = () => {
  const context = useContext(BrandingContext);

  if (!context) {
    throw new Error(
      "useBranding must be used inside BrandingProvider"
    );
  }

  return context;
};